import dayjs from 'dayjs';

export const DateFormat = (date: string): string => {
  if (window.navigator.language === 'ja') {
    return dayjs(date).format('YYYY/MM/DD HH:mm:ss');
  }
  return dayjs(date).toString();
};

export const formatBytes = (bytes: number, decimals = 2) => {
  if (bytes === 0) return '0 bytes';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};
